import type { UseQueryResult } from '@tanstack/react-query';
import { type RefObject, useEffect } from 'react';
import { useLocation } from 'react-router';

export const useConvertPolicy = ({
  el,
  query,
}: {
  el: RefObject<HTMLElement>;
  query: UseQueryResult<string, Error>;
}) => {
  const location = useLocation();

  useEffect(() => {
    if (query.data && el.current) {
      // 컨플의 타이틀에서 링크 복사 el 삭제
      Array.from(
        el.current.querySelectorAll(
          '.heading-anchor-wrapper, [data-testid="visually-hidden-heading-anchor"]'
        )
      ).forEach((target) => {
        target.remove();
      });

      // 빈값 삭제
      Array.from(el.current.querySelectorAll('p')).forEach((child) => {
        if (child.getHTML() === '&nbsp;') {
          child.remove();
        }
      });
    }

    // queryparam으로 scroll 시키는 기능
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const initAnchorType = (searchParams.get('initAnchor') || '') as string;

      if (initAnchorType) {
        const pos = scrollInfo[initAnchorType];
        const targetEl = el.current?.querySelector(
          `[data-renderer-start-pos="${pos}"]`
        );
        if (targetEl) {
          const y = targetEl.getBoundingClientRect().top + window.scrollY - 30; // ← 여백 80px 주기
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    }
  }, [query.data]);
};

// 스크롤 하고자 하는 조항의 element data-renderer-start-pos value로 정의
const scrollInfo: { [key: string]: string } = {
  PURCHASE: '1246',
};
